import { render, staticRenderFns } from "./NoPoints.vue?vue&type=template&id=73c9f28c&scoped=true"
import script from "./NoPoints.vue?vue&type=script&lang=ts"
export * from "./NoPoints.vue?vue&type=script&lang=ts"
import style0 from "./NoPoints.vue?vue&type=style&index=0&id=73c9f28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c9f28c",
  null
  
)

export default component.exports